import { createFileRoute } from "@tanstack/react-router";
import { RulesScreen } from "../components/settings/rules-screen.tsx";
import { SettingsLoading } from "../components/settings/shell.tsx";
import { useSettingsFranchise } from "../components/settings/use-settings-franchise.ts";

export const Route = createFileRoute("/installningar/bokningsregler")({ component: Screen });

function Screen() {
  const franchise = useSettingsFranchise();
  if (franchise === null) return <SettingsLoading />;
  return <RulesScreen franchiseId={franchise.id} />;
}
